import { IModel } from '../base/annotation';
import { ExpressCustomSetup, expressCustomSetupTypes } from './expressCustomSetup';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { format, stringIsNullOrEmpty } from '../../shared/utils/string.util';
import { Metamodel } from '../base/model';

@Metamodel.model({
    name: 'SqlServerAlias',
    display: [shellStringResources.ModelName_SqlServerAliasExtension, shellStringResources.ModelName_SqlServerAliasExtensions]
})
export class SqlServerAliasSetup extends ExpressCustomSetup {
    public static readonly MODEL: IModel;

    public aliasName: string;
    public serverName: string;
    public port: string;

    constructor(name?: string, public description?: string) {
        super(expressCustomSetupTypes.SqlServerAlias, name, description);
    }

    public getCustomSetupName(): string {
        return format(shellStringResources.IRCreation_SSIS_CustomSetup_SqlServerAlias_Format, this.aliasName, this.serverName, this.port);
    }

    public coincideWith(customSetup: ExpressCustomSetup): void {
        if (this.customSetupType === customSetup.customSetupType) {
            const setup = customSetup as SqlServerAliasSetup;
            this.aliasName = setup.aliasName;
            this.serverName = setup.serverName;
            this.port = setup.port;
        }
    }

    public validate(): boolean {
        return this.isValidProperty(this.aliasName) && this.isValidProperty(this.serverName) && !stringIsNullOrEmpty(this.port);
    }

    private isValidProperty(property: string): boolean {
        return !stringIsNullOrEmpty(property) && property.indexOf(' ') === -1;
    }
}
